import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/all.css";
import { Provider } from "react-redux";
import MyStore from "./service/globalData";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={MyStore}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Provider>
);
